

<!-- <div class="app-footer">
  <div class="directory-footer">
    <div class="container">
      <div class="row">
      <h4><a [routerLink]="['/memberDirectory']" routerLinkActive="router-link-active" >Member Directory</a></h4>
        <h4>
          <span>GigSumo Member Directory :</span>
          <ul>
            <li (click)="getvalue(l)" *ngFor="let l of letterArray">{{ l }}</li>
          </ul>
        </h4>
      </div>
    </div>
  </div>
  <div class="main-footer">
    <div class="container">
      <div class="row">
        <div class="col-md-3 col-sm-6 col-xs-12">
          <div class="footer-1">
            <h5>GigSumo</h5>
            <div class="footer-logo">
                <img src="assets/images/mylogo.png" />
              <img _ngcontent-serverapp-c4="" src="assets/icon/careOnline_icon.jpg" style="width: 165px;">
            </div>
            <div class="footer-address">
              <address>
                <strong>GigSumo, Inc.</strong><br />
                2591 Dallas Parkway Suite 300,<br />
                Dallas, TX 75034<br />
                <abbr title="Phone">P:</abbr> (123) 456-7890
              </address>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 col-xs-12">
          <div class="footer-2">
            <h5>Company</h5>
            <div class="footer-menu">
              <ul>
                <li><a>Help</a></li>
                <li><a>About Us</a></li>
                <li><a>News</a></li>
                <li><a>Blog</a></li>
                <li><a>Careers</a></li>
                <li><a>Policies</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 col-xs-12">
          <div class="footer-3">
            <h5>Directories</h5>
            <div class="footer-menu">
              <ul>
                <li>
                   target="_blank" href="{{profDirectoryUrl}}"
                  <a>Healthcare Professionals</a
                  >
                </li>
                <li>
                   href="{{orgDirectoryUrl}}"
                  <a >Healthcare Organization</a
                  >
                </li>
                <li><a>Communities</a></li>
                <li><a>Jobs</a></li>
                <li><a>Pulse</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 col-xs-12">
          <div class="footer-4">
            <h5>NewsLetter</h5>
            <p>Email address:</p>
            <form class="form-inline app-form margin-bottom-30">
              <div class="form-group">
                <input
                  type="email"
                  class="form-control"
                  placeholder="Your email address"
                />
              </div>
              <button type="submit" class="btn footer-subscribe-btn">
                Subscribe
              </button>
            </form>
            <h5>Social Media</h5>
            <div class="footer-social-icon">
              <ul>
                <li>
                  <a><ng-icon name="simpleFacebook"></ng-icon></a>
                </li>
                <li>
                  <a><ng-icon name="simpleTwitter"></ng-icon></a>
                </li>
                <li>
                  <a><ng-icon name="simpleLinkedin"></ng-icon></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="sub-footer">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-sm-6 col-xs-12">
          <span>Copyright © 2019 GigSumo, Inc. All rights reserved</span>
        </div>
        <div class="col-md-6 col-sm-6 col-xs-12">
          <div class="sub-footer-menu">
            <ul>
              <li>
                <a>Privacy Policy</a>
              </li>
              <li>
                <a>Terms & Conditions</a>
              </li>
              <li>
                <a>Notice Of Privacy Practices</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="panel-footer">
        <div class="row">
          <div class="col-sm-3">
            <UL>
              <li><h5>COMPORATE HEADQUARTERS</h5></li>
              <li><img src="../../../assets/images/c1.JPG" alt=""></li>
              <li><ng-icon name="tablerMapPin"></ng-icon><span>
                GigSumo , lnc<br>
                 2591 Dallas Parkway Suite 300 <br>
                 Dallas, TX75034
              </span>
                </li>
              <li><ng-icon name="tablerPhone"></ng-icon> +1 877 454 6500</li>
              <li><ng-icon name="tablerMail"></ng-icon> Sales@CareOnline.com</li>
            </UL>
          </div>
          <div class="col-sm-3">
              <ul>
              <li><h5>SOLUTION</h5></li>
              <li><a href="">health</a></li>
              <li><a href="">Physican</a></li>
              <li><a href="">Personal</a></li>
            </ul>
          </div>
          <div class="col-sm-3">
            <ul>
              <li><h5>COMPANY</h5></li>
              <li><a href="">About As</a></li>
              <li><a href="">Partners</a></li>
              <li><a href="">Associates</a></li>
            </ul>
          </div>
          <div class="col-sm-3">
            <ul>
              <li><h5>NEWS LETTERS</h5></li>
              <li>
                <div class="input-group" >
                  <input type="text" class="form-control" placeholder="Search for...">
                  <span class="input-group-btn">
                    <button class="btn btn-info" type="button">Subscription</button>
                  </span>
                </div>
              </li>
              <li>
                <ul style="margin-top: 1rem;">
                  <li>Social Media</li>
                </ul>
                <ul class="l">
                  <li><ng-icon name="simpleFacebook"></ng-icon></li>
                  <li><ng-icon name="simpleLinkedin"></ng-icon></li>
                  <li><ng-icon name="simpleTwitter"></ng-icon></li>
                </ul>
               </li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
              <strong>CareOnline</strong><br/>Copyright © 2015 GigSumo Inc. All Rights Reserved
          </div>
      </div>
      </div> -->
<!-- </div>   -->

<!-- <link rel="stylesheet" type="text/css" href="src/assets/newassets/bootstrap/css/bootstrap.min.css"> -->
<!-- <link rel="stylesheet" type="text/css" href="src/assets/newassets/custom.css"> -->
 <!-- <section class="footer py-4 cm-b-bottom app-font-family"  style=" position: relative; padding-top: 1.5rem!important; padding-bottom: 1.5rem!important;">
  <div class="container">
    <div class="row">
      <div class="col-md-5 col-12 py-3">
        <a href="https://gigsumo.com/" >
          <img src="assets/icon/gigsumologo_bigface.png"  style="width: 200px;" class="img-fluid logo">
        </a>
      </div>
      <div class="col-md-3 ft-nav py-3 col-6">
        <h3 class="ft-nav app-font-family">Gigsumo For</h3>
        <a href="https://gigsumo.com/recruiters.html">Recruiters</a>
        <a href="https://gigsumo.com/bench-sales.html">Bench recruiters</a>
        <a href="https://gigsumo.com/job-seekers.html">Job Seekers</a>


      </div>

      <div class="col-md-2 ft-nav py-3 col-6">
        <h3  class="ft-nav app-font-family ">Company</h3>
        <a href="https://gigsumo.com/about-us.html">About us</a>
        <a href="https://gigsumo.com/benefits.html">Benefits</a> 
        <a href="https://gigsumo.com/contact-sale.html">Contact Sales</a>
        <a href="https://gigsumo.com/book-a-demo.html">Book a demo</a>

      </div>
    </div>
    <img  class="upArrow" id="upArrow" (click)="scrollTop()" src="../../../assets/Uparrow.png" alt="" width="40" height="40">
  </div>
</section>


<section class="footer-copywrite py-4" style="background-color: #fff;  text-align: center;  padding-top: 1.5rem!important;    padding-bottom: 1.5rem!important;">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-md-12 py-1 fc-nav1 font new-align app-font-family">
        <a >© 2025 Gigsumo. All right reserved.   <span *ngIf="envName!='prod'"> Env: {{envName}} - </span><span> V({{versions}} || {{serverVersion}})</span> </a>
        <a href="https://gigsumo.com/privacy-policy.html">Privacy Policy</a>
        <a href="https://gigsumo.com/terms-conditions.html">Terms & Conditions</a>
        <a href="https://gigsumo.com/dmca-policy.html">DMCA Policy</a>
        <a href="https://gigsumo.com/trademark-policy.html">Trademark Policy</a>
        <a href="https://gigsumo.com/acceptable-use-policy.html">Acceptable Use Policy</a>
        <a ><ng-icon name="simpleFacebook" aria-hidden="true"></ng-icon></a>
        <a ><ng-icon name="simpleInstagram" aria-hidden="true"></ng-icon></a>

  <a ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="13" height="13">
    <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/></svg>
</a>
<a target="_blank" href="https://www.linkedin.com/company/gigsumo/posts/?feedView=all"><ng-icon name="simpleLinkedin" aria-hidden="true"></ng-icon></a>
      </div>
    </div>
  </div>
</section> -->

<footer class="footer">
  <!-- <div class="footer-content"> -->
    <!-- Logo Section -->
    <!-- <img src="/assets/params/images/logo/gigsumologo_final.png" alt="Gigsumo" class="logo-img"> -->
    <!-- <div class="footer-logo-section">
      <a target="_blank" href="{{ENVIRONMENT.ssrUrl}}" class="footer-logo">
        <img src="../../../assets/icon/gigsumologo_bigface.png" alt="Gigsumo" class="logo-img">
      </a>
    </div> -->

    <!-- Links Sections -->
    <!-- <div class="footer-links-container"> -->
      <!-- Gigsumo For Section -->
      <!-- <div class="footer-section">
        <h3 class="footer-heading">Gigsumo For</h3>
        <ul class="footer-list">
          <li><a  target="_blank" href="{{ENVIRONMENT.ssrUrl}}web/recruiters.html">Recruiters</a></li>
          <li><a  target="_blank" href="{{ENVIRONMENT.ssrUrl}}web/bench-sales.html">Bench Recruiters</a></li>
          <li><a  target="_blank" href="{{ENVIRONMENT.ssrUrl}}web/job-seekers.html">Job Seekers</a></li>
        </ul>
      </div> -->

      <!-- Resources Section -->
      <!-- <div class="footer-section">
        <h3 class="footer-heading">Resources</h3>
        <ul class="footer-list">
          <li><a target="_blank" href="{{ENVIRONMENT.ssrUrl}}web/faq.html">FAQs</a></li>
        </ul>
      </div> -->

      <!-- <div class="footer-section">
        <h3 class="footer-heading">Directories</h3>
        <ul class="footer-list"> 
            <li><a target="_blank" href="{{ENVIRONMENT.ssrUrl}}directory/all" routerlinkactive class="footer-link-two-2">Companies</a></li>
            <li><a target="_blank" href="{{ENVIRONMENT.ssrUrl}}jobs/job-details/all" routerlinkactive class="footer-link-two-2">Jobs</a></li>
            <li><a target="_blank" href="{{ENVIRONMENT.ssrUrl}}jobs/candidate-details/all" routerlinkactive class="footer-link-two-2">Talents</a></li>
          </ul>
        </div> -->
        <!-- <li><a target="_blank" href="/" class="footer-link-two-2">Jobs</a></li>  -->

      <!-- Company Section -->
      <!-- <div class="footer-section">
        <h3 class="footer-heading">Company</h3>
        <ul class="footer-list">
          <li><a target="_blank" href="{{ENVIRONMENT.ssrUrl}}web/about-us.html">About us</a></li>
          <li><a target="_blank" href="{{ENVIRONMENT.ssrUrl}}web/benefits.html">Benefits</a></li>
          <li><a target="_blank" href="{{ENVIRONMENT.ssrUrl}}web/contact-sale.html">Contact Sales</a></li>
          <li><a target="_blank" href="{{ENVIRONMENT.ssrUrl}}web/book-a-demo.html">Book a Demo</a></li>
        </ul>
      </div> -->
    <!-- </div> -->
  <!-- </div> -->

  <!-- Bottom Bar -->
  <div class="footer-bottom">
    <div class="footer-bottom-content">
      <!-- Copyright and Legal Links -->
      <!-- <div class="legal-links">
        <span class="copyright">© {{currentYear}} Gigsumo. All rights reserved.</span>
        <span *ngIf="envName!='prod'">{{envName | titlecase}} </span><span> v{{versions}} | v{{serverVersion}}</span> 
        <a target="_blank" href="{{ENVIRONMENT.ssrUrl}}web/privacy-policy.html">Privacy Policy</a>
        <a target="_blank" href="{{ENVIRONMENT.ssrUrl}}web/terms-conditions.html">Terms & Conditions</a>
        <a target="_blank" href="{{ENVIRONMENT.ssrUrl}}web/dmca-policy.html">DMCA Policy</a>
        <a target="_blank" href="{{ENVIRONMENT.ssrUrl}}web/trademark-policy.html">Trademark Policy</a>
        <a target="_blank" href="{{ENVIRONMENT.ssrUrl}}web/acceptable-use-policy.html">Acceptable Use Policy</a>
      </div> -->

      <div class="legal-links">
        <a target="_blank" href="{{ENVIRONMENT.ssrUrl}}web/privacy-policy.html">Privacy Policy</a>
        <span>.</span>
        <a target="_blank" href="{{ENVIRONMENT.ssrUrl}}web/terms-conditions.html">Terms & Conditions</a>
        <!-- <span class="copyright">© {{currentYear}} Gigsumo. All rights reserved.</span> -->
        <span class="float:right;" *ngIf="envName!='prod'">{{envName | titlecase}} </span>
        <span> v{{versions}} | v{{serverVersion}}</span> 
      </div>

      <!-- Social Media Links -->
      <!-- <div class="social-links">
        <a target="_blank" href="https://facebook.com" target="_blank" aria-label="Facebook">
          <div class="social-icon w-embed"><svg width="24" height="24" viewbox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M16.5 6H13.5C12.9477 6 12.5 6.44772 12.5 7V10H16.5C16.6137 9.99748 16.7216 10.0504 16.7892 10.1419C16.8568 10.2334 16.8758 10.352 16.84 10.46L16.1 12.66C16.0318 12.8619 15.8431 12.9984 15.63 13H12.5V20.5C12.5 20.7761 12.2761 21 12 21H9.5C9.22386 21 9 20.7761 9 20.5V13H7.5C7.22386 13 7 12.7761 7 12.5V10.5C7 10.2239 7.22386 10 7.5 10H9V7C9 4.79086 10.7909 3 13 3H16.5C16.7761 3 17 3.22386 17 3.5V5.5C17 5.77614 16.7761 6 16.5 6Z"
                fill="CurrentColor"></path>
            </svg></div>
        </a>
        <a target="_blank" href="https://instagram.com" target="_blank" aria-label="Instagram">
          <div class="social-icon w-embed"><svg width="24" height="24" viewbox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M16 3H8C5.23858 3 3 5.23858 3 8V16C3 18.7614 5.23858 21 8 21H16C18.7614 21 21 18.7614 21 16V8C21 5.23858 18.7614 3 16 3ZM19.25 16C19.2445 17.7926 17.7926 19.2445 16 19.25H8C6.20735 19.2445 4.75549 17.7926 4.75 16V8C4.75549 6.20735 6.20735 4.75549 8 4.75H16C17.7926 4.75549 19.2445 6.20735 19.25 8V16ZM16.75 8.25C17.3023 8.25 17.75 7.80228 17.75 7.25C17.75 6.69772 17.3023 6.25 16.75 6.25C16.1977 6.25 15.75 6.69772 15.75 7.25C15.75 7.80228 16.1977 8.25 16.75 8.25ZM12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5027 10.8057 16.0294 9.65957 15.1849 8.81508C14.3404 7.97059 13.1943 7.49734 12 7.5ZM9.25 12C9.25 13.5188 10.4812 14.75 12 14.75C13.5188 14.75 14.75 13.5188 14.75 12C14.75 10.4812 13.5188 9.25 12 9.25C10.4812 9.25 9.25 10.4812 9.25 12Z"
                fill="CurrentColor"></path>
            </svg></div>
        </a>
        <a target="_blank" href="https://x.com/" target="_blank" aria-label="Twitter">
          <div class="social-icon w-embed"><svg xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="18" height="24" viewBox="0 0 24 24"
              style="enable-background:new 0 0 24 24;" xml:space="preserve">
              <path
                d="M14.095479,10.316482L22.286354,1h-1.940718l-7.115352,8.087682L7.551414,1H1l8.589488,12.231093L1,23h1.940717  l7.509372-8.542861L16.448587,23H23L14.095479,10.316482z M11.436522,13.338465l-0.871624-1.218704l-6.924311-9.68815h2.981339  l5.58978,7.82155l0.867949,1.218704l7.26506,10.166271h-2.981339L11.436522,13.338465z" />
            </svg></div>
        </a>
        <a target="_blank" href="https://www.linkedin.com/company/gigsumo/posts/?feedView=all" target="_blank" aria-label="LinkedIn">
          <div class="social-icon w-embed"><svg width="24" height="24" viewbox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3ZM8 18C8.27614 18 8.5 17.7761 8.5 17.5V10.5C8.5 10.2239 8.27614 10 8 10H6.5C6.22386 10 6 10.2239 6 10.5V17.5C6 17.7761 6.22386 18 6.5 18H8ZM7.25 9C6.42157 9 5.75 8.32843 5.75 7.5C5.75 6.67157 6.42157 6 7.25 6C8.07843 6 8.75 6.67157 8.75 7.5C8.75 8.32843 8.07843 9 7.25 9ZM17.5 18C17.7761 18 18 17.7761 18 17.5V12.9C18.0325 11.3108 16.8576 9.95452 15.28 9.76C14.177 9.65925 13.1083 10.1744 12.5 11.1V10.5C12.5 10.2239 12.2761 10 12 10H10.5C10.2239 10 10 10.2239 10 10.5V17.5C10 17.7761 10.2239 18 10.5 18H12C12.2761 18 12.5 17.7761 12.5 17.5V13.75C12.5 12.9216 13.1716 12.25 14 12.25C14.8284 12.25 15.5 12.9216 15.5 13.75V17.5C15.5 17.7761 15.7239 18 16 18H17.5Z"
                fill="CurrentColor"></path>
            </svg></div>
        </a>
      </div> -->
    </div>
  </div>
</footer>